import { Box, BoxProps, styled } from '@mui/material';
import { forwardRef } from 'react';

export const MapControlContent = styled(
  forwardRef<HTMLDivElement, BoxProps>((props, ref) => (
    <Box
      ref={ref}
      {...props}
      sx={{
        ...props.sx,
      }}
    />
  ))
)({});
